import API_CONFIG from '@/config';
import base from '@/plugins/baseHttp';

import {
  formatFile,
  formatFile2,
  formatDocument,
  processFileResponse,
  processDocumentTypeResponse,
  processDocumentResponse,
  formatDocumentType,
} from './utils';

const FILE_URL = `${API_CONFIG.API}/file`;
const DOCUMENT_URL = `${FILE_URL}/document`;
const IMAGE_URL = `${FILE_URL}/image`;
const DOCUMENT = `${API_CONFIG.API}/node/document`;
const DOCUMENT_INCLUDED = '?include=file,document_type,document_needed';
const DOCUMENT_TYPE = `${API_CONFIG.API}/node/document_type`;

export default {
  getDocument(document) {
    return base.get(`${DOCUMENT}/${document.id}${DOCUMENT_INCLUDED}`)
      .then(response => processDocumentResponse(response));
  },
  saveDocument(document) {
    return base.post(`${DOCUMENT}${DOCUMENT_INCLUDED}`, { data: formatDocument(document) })
      .then(documentResponse => processDocumentResponse(documentResponse));
  },
  updateDocument(document) {
    return base.patch(`${DOCUMENT}/${document.id}${DOCUMENT_INCLUDED}`, { data: formatDocument(document) })
    .then(documentResponse => processDocumentResponse(documentResponse));
  },
  uploadFile(file, user) {
    return this.readDocumentFromLocal(file)
      .then((data) => {
        const processData = data.substr(data.lastIndexOf('base64') + 7);
        const newFile = {
          data: processData,
          uri: file.uri,
        };
        if (file.type.startsWith('image')) {
          newFile.type = 'file--image';
          return base.post(`${DOCUMENT_URL}`, { data: formatFile2(newFile, user) });
        } else if (file.type.startsWith('application')) {
          newFile.type = 'file--document';
        }
        return base.post(`${DOCUMENT_URL}`, { data: formatFile2(newFile, user) });
      })
      .then(fileResponse => processFileResponse(fileResponse));
  },
  removeDocument(document) {
    let promise;
    if (document.file && document.file.id && document.file.id !== 'dummy') {
      promise = this.removeFile(document.file);
    } else {
      promise = Promise.resolve();
    }
    return promise.then(() => base.delete(`${DOCUMENT}/${document.id}`));
  },
  removeFile(file) {
    let promise;
    if (file.filemime.startsWith('application')) {
      promise = base.delete(`${DOCUMENT_URL}/${file.id}`);
    } else if (file.filemime.startsWith('image')) {
      promise = base.delete(`${IMAGE_URL}/${file.id}`);
    } else {
      promise = Promise.reject('The file should be a document or an image');
    }
    return promise;
  },
  saveFile(file) {
    let promise;
    if (file.filemime.startsWith('application')) {
      file.type = 'file--document';
      promise = base.post(`${DOCUMENT_URL}`, { data: formatFile(file) });
    } else if (file.filemime.startsWith('image')) {
      file.type = 'file--image';
      promise = base.post(`${IMAGE_URL}`, { data: formatFile(file) });
    } else {
      promise = Promise.resolve();
    }
    return promise.then(fileResponse => processFileResponse(fileResponse));
  },
  getDocumentTypes() {
    return base.get(`${DOCUMENT_TYPE}`).then(response => processDocumentTypeResponse(response));
  },
  saveDocumentType(documentType) {
    return base.post(`${DOCUMENT_TYPE}`, { data: formatDocumentType(documentType) })
      .then(documentTypeResponse => processDocumentTypeResponse(documentTypeResponse));
  },
  updateDocumentType(documentType) {
    return base.patch(`${DOCUMENT_TYPE}/${documentType.id}`, { data: formatDocumentType(documentType) })
      .then(documentTypeResponse => processDocumentTypeResponse(documentTypeResponse));
  },
  removeDocumentType(documentType) {
    return base.delete(`${DOCUMENT_TYPE}/${documentType.id}`);
  },
  readDocumentFromLocal(file) {
    return this.pFileReader(file).then(event => event.target.result);
  },
  pFileReader(file) {
    return new Promise((resolve) => {
      const fr = new FileReader();
      fr.onload = resolve;
      fr.readAsDataURL(file);
    });
  },
};



// WEBPACK FOOTER //
// ./src/features/documents/services.js